import "./error.css";
import errorImage from "./errorImage.png";

const ErrorPage = ({ error }) => {
	return (
		<div className="error-page">
			<h1>Ojoj! Nekaj je šlo narobe!</h1>
			<h2>{error}</h2>
			<img src={errorImage} alt="broken server" />
			<h2>Poskusi znova kasneje.</h2>
		</div>
	);
};
export default ErrorPage;
